import {
  GET_PAID_SUCCESS,
  GET_PAID_FAILED,
  CLEAR_GET_PAID,
} from '../../actionTypes';

const initialState = {
  status: '',
  message: '',
  results: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_PAID_SUCCESS:
      return {
        ...state,
        status: 'success',
        message: action.message,
        results: action.results,
      };
    case GET_PAID_FAILED:
      return { ...state, status: 'error', error: action.error };
    case CLEAR_GET_PAID:
      return { ...initialState, status: 'clear' };
    default:
      return state;
  }
};
